import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import Filter from './Filter';

const ActivityFilter = ({ filter, onChange, facilitiesSearchResponse, isCategoryFilter }) => {
  const [uniqueActivities, setUniqueActivities] = useState([]);

  const doActivityChange = (value) => {
    if (filter !== value && typeof onChange === 'function') {
      onChange(value);
    }
  };

  useEffect(() => {
    const uniqueActivities = [];
    const facilityItems = facilitiesSearchResponse['imin:item'] || [];
    let tempActivities = [];

    if (facilityItems.length > 0) {
      for (const facility of facilityItems) {
        const attribute = isCategoryFilter ? 'category' : 'activity';
        if (facility[attribute] instanceof Array && facility[attribute].length) {
          if (!isCategoryFilter) {
            tempActivities = tempActivities.concat(facility[attribute]);
          } else {
            tempActivities = tempActivities.concat(
              facility[attribute].map((category) => ({
                prefLabel: category,
              }))
            );
          }
        }
      }
    } else {
      // stop execution of useEffect early as no activities/categories exist...
      return;
    }

    for (const activity of tempActivities) {
      if (activity.prefLabel && uniqueActivities.indexOf(activity.prefLabel) < 0) {
        uniqueActivities.push(activity.prefLabel);
      }
    }
    for (const activity of filter) {
      if (uniqueActivities.indexOf(activity) < 0) {
        uniqueActivities.push(activity);
      }
    }
    uniqueActivities.sort();

    const mappedActivities = uniqueActivities.map((value) => ({
      label: value,
      value,
    }));

    setUniqueActivities(mappedActivities);
  }, [facilitiesSearchResponse, isCategoryFilter]);

  if (uniqueActivities.length > 0) {
    return (
      <Filter
        id="Activity"
        defaultCaption={isCategoryFilter ? 'All categories' : 'All activities'}
        plural={isCategoryFilter ? 'categories' : 'activities'}
        value={filter}
        onChange={(value) => doActivityChange(value)}
        multiple={true}
        options={uniqueActivities}
      />
    );
  }
  return null;
};

ActivityFilter.propTypes = {
  filter: PropTypes.array,
  onChange: PropTypes.func,
  facilitiesSearchResponse: PropTypes.shape({
    item: PropTypes.array,
    'imin:item': PropTypes.array,
  }),
  provider: PropTypes.string,
  isCategoryFilter: PropTypes.bool,
};

export default ActivityFilter;
